/**
 * What `/` renders: the deployment's landing variant, read once from the
 * shell the server stamped.
 *
 * `full` is the canonical landing page with the intake composer, exactly as
 * before. `coming-soon` is the private-beta page. Nothing here — or anywhere
 * in the application — consults the hostname; the server said which one
 * this deployment shows, and the answer was in the document before React
 * ran, so the first paint is the right page. Every other route, including
 * the intake preview, sign-in and the OAuth callbacks, is untouched by the
 * choice.
 */

import type { ReactNode } from 'react';

import { PublicEarlyAccessPage } from '../coming-soon/index.js';
import { readLandingVariant } from '../../shell/landing-variant.js';
import { LandingPage } from './LandingPage.js';

export function LandingRoute(): ReactNode {
  return readLandingVariant() === 'coming-soon' ? (
    <PublicEarlyAccessPage />
  ) : (
    <LandingPage />
  );
}
